/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react'

import { Formik, Form } from 'formik';
import * as Yup from 'yup'
import TextField from '../Common/Fields/TextField';
import LoadingButton from '@mui/lab/LoadingButton';
import { Button, Typography } from '@mui/material';
// import DatePicker from '../Common/Fields/DatePickerField';
import SelectField from '../Common/Fields/SelectField';
import { STATUS_FILTER_OPTIONS } from './Options/DocketForm';
import { CIRCUIT_TYPE_OPTIONS } from './Options/CircuitForm';
import { formatSelectOptionsList, useHirerList } from '../../hooks/circuit';
import Loader2 from '../Common/Loader2';
// import { useProviderList } from '../../hooks/core/provider';
import { getLocal } from '../../utils/localStorage';
import { CURRENT_PROVIDER_LOCAL_DATA } from '../../config';
import { formatUserOptionsList, useUser, useUsersList } from '../../hooks/user';
// import DateTimePicker from '../Common/Fields/DateTimePickerField';
import Datetime from 'react-datetime';
import moment from 'moment';
import { formatDateTime } from '../../utils/shortcuts';
import CheckboxField from '../Common/Fields/CheckboxField';

export default function DocketFilterForm({ isLoading, handleSubmit, setModal, resetFrom, searchParams }) {
    const { user } = useUser();
    const { hirerData, HirerIsLoading } = useHirerList();
    const fiber_tl = useUsersList('?user_role=FTL');  // Fiber Team Leader *
    const techinicians = useUsersList('?user_role=FT');  // Technician *
    const [params, setParams] = useState({});
    const [loading, setLoading] = useState(true);
    const currentProvider = JSON.parse(getLocal(CURRENT_PROVIDER_LOCAL_DATA))

    const [isCollapsed, setIsCollapsed] = useState(true);

    const toggleCollapse = () => {
        setIsCollapsed(!isCollapsed);
    };

    useEffect(() => {
        const currentParams = Object.fromEntries([...searchParams]);
        setParams(currentParams)
        setLoading(false)
    }, [searchParams])

    const validate = Yup.object({
        q: Yup.string(),
        status: Yup.string(),
        hirer_name: Yup.string().nullable(),
        docket_id: Yup.string(),
        circuit__code: Yup.string(),
        circuit__office_name: Yup.string(),
        fiber_team_leader: Yup.string().nullable(),
    }).shape({
        date_after: Yup.string().when('date_before', {
            is: (val) => val !== null,
            then: Yup.string().required('required').nullable(),
            otherwise: Yup.string().nullable()
        }),
        date_before: Yup.string().when('date_after', {
            is: (val) => val !== null,
            then: Yup.string().required('required').nullable(),
            otherwise: Yup.string().nullable()
        }),
    }, ['date_after', 'date_before']);

    if (loading) {
        return <Loader2 />
    }
    return (
        <Formik
            initialValues={{
                "q": params?.q ?? '',
                "date_after": params?.date_after ?? null,
                "date_before": params?.date_before ?? null,
                "status": params?.status ?? '',
                "circuit__circuit_type": params?.circuit__circuit_type ?? '',
                "hirer_name": params?.hirer_name ?? '',
                "circuit__code": params?.circuit__code ?? '',
                "circuit__office_name": params?.circuit__office_name ?? '',
                "code": params?.code ?? '',
                "docketed_by": params?.docketed_by ?? '',
                "fiber_team_leader": params?.fiber_team_leader ? parseInt(params?.fiber_team_leader) : '',
                "technician": params?.technician ? parseInt(params?.technician) : '',
                "circuit__location_a": params?.circuit__location_a ?? '',
                "circuit__location_b": params?.circuit__location_b ?? '',
                "customers_id": params?.customers_id ?? '',
                "provider": params?.provider ?? currentProvider?.id,
                "show_closed": params?.show_closed === 'true' ? true : false,
            }}
            validationSchema={validate}
            onSubmit={handleSubmit}
        >
            {formik => (

                <Form className="textFormAllField" style={{ 
                    fontSize: '13px',
                    lineHeight: '1'
                }}>
                    {/* {console.log('formdata -> ', formik)} */}
                    {['UU'].some(role => user?.roles?.includes(role)) ? <div>
                        {/* User-specific simplified view */}
                        <div className="mb-2 p-2" style={{ 
                            backgroundColor: '#f8f9fa', 
                            borderRadius: '6px',
                            border: '1px solid #e9ecef'
                        }}>
                            <div className='row g-2'>
                                <div className="col-12 mb-2">
                                    <TextField 
                                        label='Docket ID' 
                                        type="text" 
                                        name='code' 
                                        placeholder='Enter Docket ID' 
                                        style={{ fontSize: '14px' }}
                                    />
                                </div>
                                <div className="col-md-6 mb-2">
                                    <Typography variant='subtitle2' style={{ 
                                        marginBottom: '4px', 
                                        fontWeight: '600',
                                        color: '#495057',
                                        fontSize: '13px'
                                    }}>
                                        Status
                                    </Typography>
                                    <SelectField
                                        name='status'
                                        options={STATUS_FILTER_OPTIONS}
                                        value={STATUS_FILTER_OPTIONS.filter(function (option) {
                                            return option.value === formik.values.status;
                                        })}
                                        onChange={(e) => formik.setFieldValue('status', e ? e.value : '')}
                                        isClearable={true}
                                        placeholder="Select status"
                                    />
                                </div>
                                <div className="col-md-6 mb-2">
                                    <Typography variant='subtitle2' style={{ 
                                        marginBottom: '4px', 
                                        fontWeight: '600',
                                        color: '#495057',
                                        fontSize: '13px'
                                    }}>
                                        Show Closed Dockets
                                    </Typography>
                                    <div style={{ 
                                        padding: '6px',
                                        backgroundColor: '#fff',
                                        borderRadius: '4px',
                                        border: '1px solid #ced4da'
                                    }}>
                                        <CheckboxField label='Include closed dockets' name='show_closed' options={['Show Closed']} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div> : <div>
                        {/* Main search input */}
                        
                            <div className='row mb-2'>
                                <div className="col-12">
                                    <TextField 
                                        label='Quick Search' 
                                        type="text" 
                                        name='q' 
                                        placeholder='Search by docket ID, circuit ID, location...' 
                                        style={{ fontSize: '14px' }}
                                    />
                                </div>
                            </div>

                        {/* Advanced filters toggle */}
                        <div className="d-flex justify-content-between align-items-center mb-2">
                            <h6 className="mb-0" style={{ color: '#495057', fontWeight: '600', fontSize: '14px' }}>
                                Advanced Filters
                            </h6>
                            <button 
                                type='button' 
                                className='btn btn-outline-primary btn-sm d-flex align-items-center gap-1' 
                                onClick={toggleCollapse}
                                style={{
                                    borderRadius: '16px',
                                    padding: '4px 12px',
                                    fontSize: '12px',
                                    fontWeight: '500'
                                }}
                            >
                                <span>{isCollapsed ? 'Show More' : 'Show Less'}</span>
                                <span className="material-icons-sharp" style={{ fontSize: '16px' }}>
                                    {isCollapsed ? 'expand_more' : 'expand_less'}
                                </span>
                            </button>
                        </div>

                        {/* Collapsible advanced filters */}
                        {!isCollapsed && (
                            <div className="mb-2 p-2" style={{ 
                                backgroundColor: '#f8f9fa', 
                                borderRadius: '6px',
                                border: '1px solid #e9ecef'
                            }}>
                                <h6 style={{ color: '#495057', marginBottom: '12px', fontWeight: '600', fontSize: '13px' }}>
                                    Specific Filters
                                </h6>
                                <div className='row g-2 mb-3'>
                                    <div className="col-md-4">
                                        <TextField 
                                            label='Docket ID' 
                                            type="text" 
                                            name='code' 
                                            placeholder='Exact docket ID' 
                                        />
                                    </div>
                                    <div className="col-md-4">
                                        <TextField 
                                            label='Circuit ID' 
                                            type="text" 
                                            name='circuit__code' 
                                            placeholder='Exact circuit ID' 
                                        />
                                    </div>
                                    <div className="col-md-4">
                                        <TextField 
                                            label='Customer ID' 
                                            type="text" 
                                            name='customers_id' 
                                            placeholder='Customer ID' 
                                        />
                                    </div>
                                </div>

                                <h6 style={{ color: '#495057', marginBottom: '12px', fontWeight: '600', fontSize: '13px' }}>
                                    Location Filters
                                </h6>
                                <div className='row g-2 mb-3'>
                                    <div className="col-md-4">
                                        <TextField 
                                            label='Location A' 
                                            type="text" 
                                            name='circuit__location_a' 
                                            placeholder='Starting location' 
                                        />
                                    </div>
                                    <div className="col-md-4">
                                        <TextField 
                                            label='Location B' 
                                            type="text" 
                                            name='circuit__location_b' 
                                            placeholder='Ending location' 
                                        />
                                    </div>
                                    <div className="col-md-4">
                                        <TextField 
                                            label='Office Name' 
                                            type="text" 
                                            name='circuit__office_name' 
                                            placeholder='Office name' 
                                        />
                                    </div>
                                </div>

                                <div className='row g-2 mb-3'>
                                    <div className="col-md-12">
                                        <TextField 
                                            label='Docketed By' 
                                            type="text" 
                                            name='docketed_by' 
                                            placeholder='Created by' 
                                        />
                                    </div>
                                </div>

                                <h6 style={{ color: '#495057', marginBottom: '12px', fontWeight: '600', fontSize: '13px' }}>
                                    Date Range
                                </h6>
                                <div className='row g-2 mb-3'>
                                    <div className="col-md-6">
                                        <Typography variant='subtitle2' style={{ 
                                            marginBottom: '4px', 
                                            fontWeight: '600',
                                            color: '#495057',
                                            fontSize: '12px'
                                        }}>
                                            From Date & Time
                                        </Typography>
                                        <Datetime
                                            value={moment(formik.values.date_after)}
                                            onChange={(e) => formik.setFieldValue('date_after', formatDateTime(e, 'YYYY-MM-DD H:m'))}
                                            name='date_after'
                                            dateFormat="DD/MM/YYYY"
                                            timeFormat="H:mm"
                                            inputProps={{
                                                placeholder: 'Start date & time',
                                                style: {
                                                    width: '100%',
                                                    padding: '8px',
                                                    borderRadius: '4px',
                                                    border: '1px solid #ced4da',
                                                    fontSize: '13px'
                                                }
                                            }}
                                        />
                                    </div>
                                    <div className="col-md-6">
                                        <Typography variant='subtitle2' style={{ 
                                            marginBottom: '4px', 
                                            fontWeight: '600',
                                            color: '#495057',
                                            fontSize: '12px'
                                        }}>
                                            To Date & Time
                                        </Typography>
                                        <Datetime
                                            value={moment(formik.values.date_before)}
                                            onChange={(e) => formik.setFieldValue('date_before', formatDateTime(e, 'YYYY-MM-DD H:m'))}
                                            name='date_before'
                                            dateFormat="DD/MM/YYYY"
                                            timeFormat="H:mm"
                                            inputProps={{
                                                placeholder: 'End date & time',
                                                style: {
                                                    width: '100%',
                                                    padding: '8px',
                                                    borderRadius: '4px',
                                                    border: '1px solid #ced4da',
                                                    fontSize: '13px'
                                                }
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                        )}

                        {/* Main filter options */}
                        <div className="mb-2 p-2" style={{ 
                            backgroundColor: '#fff', 
                            borderRadius: '6px',
                            border: '1px solid #e9ecef'
                        }}>
                            <h6 style={{ color: '#495057', marginBottom: '12px', fontWeight: '600', fontSize: '13px' }}>
                                Category Filters
                            </h6>
                            <div className='row g-2'>
                                <div className="col-md-4 mb-2">
                                    <Typography variant='subtitle2' style={{ 
                                        marginBottom: '4px', 
                                        fontWeight: '600',
                                        color: '#495057',
                                        fontSize: '12px'
                                    }}>
                                        Status
                                    </Typography>
                                    <SelectField
                                        name='status'
                                        options={STATUS_FILTER_OPTIONS}
                                        value={STATUS_FILTER_OPTIONS.filter(function (option) {
                                            return option.value === formik.values.status;
                                        })}
                                        onChange={(e) => formik.setFieldValue('status', e ? e.value : '')}
                                        isClearable={true}
                                        placeholder="Select status"
                                    />
                                </div>
                                <div className="col-md-4 mb-2">
                                    <Typography variant='subtitle2' style={{ 
                                        marginBottom: '4px', 
                                        fontWeight: '600',
                                        color: '#495057',
                                        fontSize: '12px'
                                    }}>
                                        Circuit Type
                                    </Typography>
                                    <SelectField
                                        name='circuit__circuit_type'
                                        options={CIRCUIT_TYPE_OPTIONS}
                                        value={CIRCUIT_TYPE_OPTIONS.filter(function (option) {
                                            return option.value === formik.values.circuit__circuit_type;
                                        })}
                                        onChange={(e) => formik.setFieldValue('circuit__circuit_type', e ? e.value : '')}
                                        isClearable={true}
                                        placeholder="Select circuit type"
                                    />
                                </div>
                                <div className="col-md-4 mb-2">
                                    <Typography variant='subtitle2' style={{ 
                                        marginBottom: '4px', 
                                        fontWeight: '600',
                                        color: '#495057',
                                        fontSize: '12px'
                                    }}>
                                        Hirer
                                    </Typography>
                                    <SelectField
                                        name='hirer_name'
                                        options={hirerData?.data?.map(formatSelectOptionsList)}
                                        value={hirerData?.data?.map(formatSelectOptionsList).filter(function (option) {
                                            return option.value.toString() === formik.values.hirer_name.toString();
                                        })}
                                        onChange={(e) => formik.setFieldValue('hirer_name', e ? e.value : '')}
                                        isClearable={true}
                                        isLoading={HirerIsLoading}
                                        placeholder="Select hirer"
                                    />
                                </div>
                            </div>

                            <div className='row g-2'>
                                <div className="col-md-4 mb-2">
                                    <Typography variant='subtitle2' style={{ 
                                        marginBottom: '4px', 
                                        fontWeight: '600',
                                        color: '#495057',
                                        fontSize: '12px'
                                    }}>
                                        Team Leader
                                    </Typography>
                                    <SelectField
                                        name='fiber_team_leader'
                                        options={fiber_tl?.usersData?.data?.map(formatUserOptionsList)}
                                        value={fiber_tl?.usersData?.data?.map(formatUserOptionsList).filter(function (option) {
                                            return option.value === formik.values.fiber_team_leader;
                                        })}
                                        isLoading={fiber_tl?.usersIsLoading}
                                        onChange={(e) => formik.setFieldValue('fiber_team_leader', e ? e.value : '')}
                                        isClearable={true}
                                        placeholder="Select team leader"
                                    />
                                </div>
                                <div className="col-md-4 mb-2">
                                    <Typography variant='subtitle2' style={{ 
                                        marginBottom: '4px', 
                                        fontWeight: '600',
                                        color: '#495057',
                                        fontSize: '12px'
                                    }}>
                                        Technician
                                    </Typography>
                                    <SelectField
                                        name='technician'
                                        options={techinicians?.usersData?.data?.map(formatUserOptionsList)}
                                        value={techinicians?.usersData?.data?.map(formatUserOptionsList).filter(function (option) {
                                            return option.value === formik.values.technician;
                                        })}
                                        isLoading={fiber_tl?.usersIsLoading}
                                        onChange={(e) => formik.setFieldValue('technician', e ? e.value : '')}
                                        isClearable={true}
                                        placeholder="Select technician"
                                    />
                                </div>
                                <div className="col-md-4 mb-2">
                                    <Typography variant='subtitle2' style={{ 
                                        marginBottom: '4px', 
                                        fontWeight: '600',
                                        color: '#495057',
                                        fontSize: '12px'
                                    }}>
                                        Include Closed Dockets
                                    </Typography>
                                    {/* <div style={{ 
                                        padding: '0.5px',
                                        backgroundColor: '#f8f9fa',
                                        borderRadius: '4px',
                                        border: '1px solid #ced4da'
                                    }}> */}
                                        <CheckboxField label='Show closed dockets' name='show_closed' options={['Show Closed']} />
                                    {/* </div> */}
                                </div>
                            </div>
                        </div>
                    </div>}

                    {/* Action Buttons */}
                    <div className="d-flex flex-wrap gap-2 mt-2 pt-2" style={{ 
                        borderTop: '1px solid #e9ecef'
                    }}>
                        <LoadingButton
                            loading={isLoading}
                            type="submit"
                            variant="contained"
                            size="small"
                            startIcon={<span className="material-icons-sharp" style={{ fontSize: '16px' }}>search</span>}
                            style={{
                                borderRadius: '4px',
                                padding: '6px 12px',
                                fontSize: '13px',
                                fontWeight: '600',
                                textTransform: 'none',
                                boxShadow: '0 1px 4px rgba(0, 123, 255, 0.3)'
                            }}
                        >
                            Search
                        </LoadingButton>
                        <Button 
                            variant="outlined" 
                            size="small"
                            startIcon={<span className="material-icons-sharp" style={{ fontSize: '16px' }}>clear_all</span>}
                            onClick={() => resetFrom(formik)}
                            style={{
                                borderRadius: '4px',
                                padding: '6px 12px',
                                fontSize: '13px',
                                fontWeight: '500',
                                textTransform: 'none'
                            }}
                        >
                            Clear
                        </Button>
                        <Button 
                            variant="text" 
                            size="small"
                            startIcon={<span className="material-icons-sharp" style={{ fontSize: '16px' }}>close</span>}
                            onClick={() => setModal(false)}
                            style={{
                                borderRadius: '4px',
                                padding: '6px 12px',
                                fontSize: '13px',
                                fontWeight: '500',
                                textTransform: 'none',
                                color: '#6c757d'
                            }}
                        >
                            Cancel
                        </Button>
                    </div>
                </Form>
            )}
        </Formik>
    )
}
